<template>
    <v-card class="elevation-10">
        <v-card-title>
            <v-container grid-list-md text-xs-center>
                <v-layout row wrap>
                    <v-flex xs4>
                        <v-autocomplete
                                v-model="cliente_id"
                                :items="clients"
                                label="Client"
                                item-text="company_name"
                                item-value="id"
                                clearable
                        >
                        </v-autocomplete>
                    </v-flex>
                    <v-flex xs4>
                        <v-autocomplete
                                v-model="status_id"
                                :items="statuses"
                                label="Statuses"
                                item-text="name"
                                item-value="id"
                                clearable
                        >
                        </v-autocomplete>
                    </v-flex>
                    <v-flex xs4>
                        <v-text-field
                                v-model="search"
                                append-icon="search"
                                label="Search"
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs2>
                        <v-btn :href="BASE + 'sample-orders/export?search=' + search + '&client_id=' + cliente_id + '&status_id=' + status_id + '&sortBy=' + sortBy + '&order=' + order + '&download_token=' + download_token" target="_blank">Export</v-btn>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-card-title>
        <v-data-table
                :headers="headers"
                :items="samples.data"
                :search="search"
                :pagination.sync="pagination"
                hide-actions
                :loading="loading"
                :total-items="8"
                v-on:update:pagination="ordenar"
        >
            <template slot="items" slot-scope="props">
                <td @click="changeStatus(props.item.id, props.item.status_id, true)">{{ props.item.request_ }}</td>
                <td @click="changeStatus(props.item.id, props.item.status_id, true)" class="text-xs">{{ props.item.client_company_name}}</td>
                <td @click="changeStatus(props.item.id, props.item.status_id, true)" class="text-xs">{{ props.item.track_number }}</td>
                <td @click="changeStatus(props.item.id, props.item.status_id, true)" class="text-xs">{{ props.item.status_name}}</td>
                <td @click="changeStatus(props.item.id, props.item.status_id, true)" class="text-xs">{{ props.item.date }}</td>
                <td class="layout px-0">
                    <v-btn
                            fab
                            dark
                            small
                            :href="BASE + 'sample-order/' + props.item.id + '?download_token=' + download_token"
                            target="_blank"
                            title="Donwload sample request"
                            @click="changeStatus(props.item.id, props.item.status_id, false)"
                    >
                        <v-icon>assignment</v-icon>
                    </v-btn>
                </td>
            </template>
            <v-alert slot="no-results" :value="true" color="error" icon="warning">
                Your search for "{{ search }}" found no results.
            </v-alert>
        </v-data-table>
        <div class="text-xs-center pt-4 pb-4" v-if="samples.data">
            <v-pagination
                    v-model="page"
                    :length="last_page"
                    color="secondary"
                    circle
                    :total-visible="7"
                    @input="setPage"
            ></v-pagination>
        </div>
    </v-card>
</template>

<script>
    import { BASE } from '../../../config'
    export default {
        data () {
            return {
                search: '',
                page: null,
                last_page: null,
                pagination: {sortBy: 'date', descending: true},
                loading: false,
                headers: [
                    {
                        text: 'Sample request',
                        align: 'left',
                        sortable: true,
                        value: 'request_'
                    },
                    { text: 'Client', value: 'client_id', sortable: true },
                    { text: 'Tracking number', value: 'track_number', sortable: true },
                    { text: 'Status', value: 'status_id', sortable: true },
                    { text: 'Date', value: 'date', sortable: true },
                    { text: 'Actions', value: 'action', sortable: false }
                ],
                samples: [],
                direction: 'left',
                fab: [],
                fling: false,
                hover: false,
                tabs: null,
                top: false,
                right: true,
                bottom: true,
                left: false,
                transition: 'slide-x-transition',
                BASE: BASE,
                clients: null,
                statuses: null,
                cliente_id: null,
                status_id: null,
                download_token: null,
                sortBy: 'date',
                order: 'asc',
            }
        },
        created: function() {
            this.checkUser();
            this.getSamples();
            this.getClients();
            this.getStatuses();
            this.debouncedGetSamples = _.debounce(this.getSamples, 500)
        },
        watch: {
            search: function () {
                this.loading = true;
                this.debouncedGetSamples();
            },
            last_page: function () {
                if (this.page > this.samples.meta.last_page) {
                    this.page = 1;
                }
            },
            cliente_id: function () {
                if (this.cliente_id == undefined) {
                    this.cliente_id = null;
                }
                this.getSamples();
            },
            status_id: function () {
                if (this.status_id == undefined) {
                    this.status_id = null;
                }
                this.getSamples();
            },
        },
        methods : {
            ordenar (payload) {
                this.loading = true;
                this.sortBy = payload.sortBy;
                if (payload.descending) {
                    this.order = 'desc';
                } else {
                    this.order = 'asc';
                }
                this.getSamples();
            },
            checkUser() {
                this.$store.dispatch('checkAccessToken').then((res) => {
                    this.download_token = this.$store.getters.getUser.download_token;
                }).catch((error) => {

                });
            },
            setPage (page) {
                this.page = page;
                this.getSamples();
            },
            getSamples () {
                var params = {
                    filters : {
                        search: this.search,
                        page: this.page,
                        client_id: this.cliente_id,
                        status_id: this.status_id,
                        sortBy: this.sortBy,
                        order: this.order
                    }
                };
                this.$store.dispatch('getSamples', params).then((res) => {

                    this.samples = res.data;
                    this.page = res.data.meta.current_page;
                    this.last_page = res.data.meta.last_page;
                    this.loading = false;

                    this.fab = [];

                    for (var i = 0; i < res.data.data.length; i++) {
                        this.fab.push(false);
                    }

                }).catch((error) => {

                });
            },
            getStatuses () {
                this.$store.dispatch('getStatusSampleOrders').then((res) => {
                    this.statuses = res.data.data;
                    this.statuses.splice(4, 1);
                }).catch((error) => {

                });
            },
            getClients () {
                this.$store.dispatch('getClientsSelect').then((res) => {
                    this.clients = res.data;
                }).catch((error) => {

                });
            },
            changeStatus(sample_order_id, oldStatus, open) {
                if (oldStatus == 1) {
                    this.$store.dispatch('updateStatusSampleOrders', {
                        id: sample_order_id,
                        status: 2
                    }).then((res) => {
                        if (open) {
                            this.$router.push({ name: 'ftn.sample-orders.detail', params : { id : sample_order_id } })
                        }

                    }).catch((error) => {

                    });
                }

                if (open) {
                    this.$router.push({ name: 'ftn.sample-orders.detail', params : { id : sample_order_id } })
                }

            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/fnt/samples/ListComponent.vue